exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-dialog--small[data-v-e676dff6]{width:80%!important}.talent-box[data-v-e676dff6]{padding:0 20px;margin-bottom:20px}.talent-box-item[data-v-e676dff6]{color:#666;margin-bottom:10px}.common-title[data-v-e676dff6]{display:inline-block;width:120px;text-align:right}.talent-box p[data-v-e676dff6]{padding:10px;margin-bottom:20px;background-color:#efefef}.talent-info[data-v-e676dff6]{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-e676dff6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/talent/talentDetail.vue
// module id = 637
// module chunks = 0